<template lang="pug">
.full-width
    .date_picker_container
        vm-date-picker.date_picker(:v-model="model" :value="date" type="month" size="large" :editable="false" iconCalendar="" placeholder="" @input="action")
        vm-icon.icon_date_picker(icon="calendar-outline" size="1rem")
</template>
<script>
import moment from 'moment'

export default {
  name: 'DatePikerDashboard',
  props: {
    currentDate: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      date: '',
      model: ''
    }
  },
  mounted () {
    if (this.currentDate) this.date = moment().format('YYYY-MM')
  },
  methods: {
    action (date) {
      this.$emit('action', moment(date).format('YYYY-MM'))
    }
  }
}
</script>

<style lang="scss">
.date_picker_container {
    position: relative;
    width: 100%;
    .vm-datepicker , .vm-input--input {
        width: 100%;
    }
    &:hover .vm-input--icon{
        position: absolute;
        top: 0.9rem;
        transform: scale(0.9);
    }
    .icon_date_picker {
        position: absolute;
        cursor: pointer;
        bottom: 1rem;
        right: 1rem;

        transform: scale(1.7);

        pointer-events: none;
    }
}
</style>
